
export const NOTIFICATION_ENDPOINTS  ={
LIST:"api/portal-admin/notifications",
CREATE:"api/portal-admin/upload-notification",
DETAIL: (id: string) => `api/portal-admin/user/notifications/${id}`,

}